export default __webpack_public_path__ + "static/media/006.d8b4e52e.jpg";